import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';


import {ErrorService, EventService} from '..';
import { UserGroup } from '../models/user-group';
import { User, AvailableRole } from '../models/user';
import { ConfigService } from './config.service';

@Injectable({providedIn: 'root'})
export class ProfileService {

    private profileUrl = ConfigService.getApiEndpoint() + 'v1/profile/';
    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }


    get(): Observable<User> {
        return this.http.get<User>(this.profileUrl).pipe(
            catchError(this.error.handleError('profile.get', null))
        );
    }
    getUserGroups(): Observable<User> {
        return this.http.get<UserGroup>(this.profileUrl + '/groups').pipe(
            catchError(this.error.handleError('profile.getUserGroups', null))
        );
    }
    getProjects(): Observable<User> {
        return this.http.get<UserGroup>(this.profileUrl + '/projects').pipe(
            catchError(this.error.handleError('profile.getProjects', null))
        );
    }
    getAvailableRoles(): Observable<User> {
        return this.http.get<AvailableRole>(this.profileUrl + '/availableRoles').pipe(
            catchError(this.error.handleError('profile.getAvailableRoles', null))
        );
    }

    update(user: User): Observable<User> {
        return this.http.put<User>(this.profileUrl, user).pipe(
            tap(_ => this.eventService.addAlert(`updated profile: ${user.name}`)),
            catchError(this.error.handleError('profile.update', null))
        );
    }

}
